import { UploadFile } from "@mui/icons-material";
import { Button } from "@mui/material";
import { ChangeEvent, Dispatch, SetStateAction } from "react";
import { useTranslation } from "react-i18next";

interface FileUploadProps {
  setFile: Dispatch<SetStateAction<File | null>>;
  buttonApiLoading?: boolean;
}

export const FileUploadButton = ({
  setFile,
  buttonApiLoading
}: FileUploadProps) => {
  const { t } = useTranslation();
  const handleClick = (event: ChangeEvent<HTMLInputElement>) => {
    if (!event.target.files) {
      return;
    }
    setFile(event.target.files[0]);
  };

  return (
    <Button component="label" variant="contained" startIcon={<UploadFile />}>
      {t("Upload")}
      <input type="file" accept=".csv" hidden onChange={handleClick} />
    </Button>
  );
};
